<template>
  <div id="mycfm">
    <app-header />
    <div class="container">
      <transition name="fade" mode="out-in"> <router-view></router-view> </transition>
    </div>
    <app-footer />
  </div>
</template>
<script>
import appHeader from "./components/Header";
import appFooter from "./components/Footer";

export default {
  name: "App",
  components: {
    appHeader,
    appFooter
  },
  created() {
    this.$store.dispatch("env/getEnvProperties");
  }
};
</script>
<style lang="less" scoped>
#mycfm {
  min-height: 100vh;
  position: relative;
  box-shadow: 0px 0px 5px #888888;
  background-color: #fff;
  margin: 0px 3% 0px 3%;
  height: 100%;
}

.container {
  padding: 0;
  border-radius: 10px;
  margin: 20px auto;
  min-height: calc(100vh - 180px);
}
</style>
